import {ContextMenuProps} from "../../../elements/context-menu";
import {CalendarSelectOptionsProps} from "./CalendarSelectOptions";
import {AppState} from "@stores/AppState";


export const openCalendarSelectOptionsCtxMenu = (
    appState: AppState,
    targetElement: HTMLElement,
    params: CalendarSelectOptionsProps,
    ctxMenuProps: {id: string} & Partial<ContextMenuProps>
) => {
    const maxWidth = targetElement.getBoundingClientRect().width;

    appState.addAdditionalContextMenu({
        type: 'calendar-select-options',
        isDark: false,
        menuPlacement: 'block-end',
        menuAlignment: 'start',
        VERTICAL_SHIFT: 0,
        HORIZONTAL_SHIFT: 0,
        withPointer: false,
        shouldForcePlace: true,
        getTargetBoundingBox: targetElement.getBoundingClientRect.bind(targetElement),
        params: {
            ...params,
        },
        minWidth: maxWidth,
        ...ctxMenuProps,
    });
};
